import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { ButtonGroup, IconButton } from "@mui/material";
interface Props {
	deleteItem?: (itemId: number) => void;
	edit: (itemId: number) => void;
	id: number;
}

export const EditAndDeleteButtons = ({ deleteItem, edit, id }: Props) => {
	return (
		<>
			<ButtonGroup>
				<IconButton
					color={"primary"}
					onClick={() => {
						edit(id);
					}}
					title="Edit"
				>
					<EditIcon style={{ cursor: "pointer" }} fontSize="small" />
				</IconButton>
				{deleteItem && (
					<IconButton
						color={"error"}
						onClick={() => {
							deleteItem(id);
						}}
						title="Delete"
					>
						<DeleteIcon style={{ cursor: "pointer" }} fontSize="small" />
					</IconButton>
				)}
			</ButtonGroup>
		</>
	);
};
